export default "__VITE_ASSET__CRNeLDHC__"